/* Maison Galet — The First Fifty — assets/bl-gift.js */
(function () {
  'use strict';

  /* ---------- EDIT THESE THREE LINES ---------- */
  var GIFT_VARIANT_ID = 58640279863677;
  var GIFT_HANDLE     = 'bellamy-pendant-gift';
  var GIFT_VALUE      = '';
  /* -------------------------------------------- */

  var CART_WRITE = /\/cart\/(add|change|update|clear)/;
  var busy = false;
  var observer = null;

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function syncGift() {
    if (busy) return Promise.resolve(false);
    busy = true;

    return getCart().then(function (cart) {
      var gift = null;
      var paidUnits = 0;

      cart.items.forEach(function (item) {
        if (item.variant_id === GIFT_VARIANT_ID) gift = item;
        else paidUnits += item.quantity;
      });

      if (paidUnits > 0 && !gift) {
        return postCart('/cart/add.js', {
          items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _first_fifty: 'yes' } }]
        }).then(function () { return true; });
      }
      if (paidUnits > 0 && gift && gift.quantity !== 1) {
        return postCart('/cart/change.js', { id: gift.key, quantity: 1 })
          .then(function () { return true; });
      }
      if (paidUnits === 0 && gift) {
        return postCart('/cart/change.js', { id: gift.key, quantity: 0 })
          .then(function () { return true; });
      }
      return false;
    })
    .catch(function () { return false; })
    .then(function (changed) { busy = false; return changed; });
  }

  function refreshCartUI() {
    if (/^\/cart/.test(window.location.pathname)) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') theme.cart.getCart();
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartWrite = CART_WRITE.test(url) && !busy;
    var call = nativeFetch.apply(this, arguments);
    if (!isCartWrite) return call;
    return call.then(function (response) {
      return syncGift().then(function () { return response; });
    });
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._blUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_WRITE.test(this._blUrl || '') && !busy) {
      this.addEventListener('load', function () {
        syncGift().then(function (changed) { if (changed) refreshCartUI(); });
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* ---------- dress the gift line in the cart ---------- */

  var PRICE_SEL = [
    '.cart__price', '.cart__final-price', '.cart__price--strikethrough',
    '.cart-item__price', '.cart-item__price-wrapper', '.ajaxcart__price',
    '[data-cart-item-price]', '[data-cart-item-original-price]',
    '[data-cart-item-final-price]'
  ].join(',');

  var TITLE_SEL = [
    '.cart__item-title', '.cart__product-name', '.cart__product-title',
    '.cart-item__name', '.ajaxcart__product-name'
  ].join(',');

  function decorateOnce() {
    var links = document.querySelectorAll('a[href*="/products/' + GIFT_HANDLE + '"]');
    if (!links.length) return;

    var rows = [];
    Array.prototype.forEach.call(links, function (link) {
      var row = link.closest('tr, .cart__item, .cart-item, .ajaxcart__product, li');
      if (row && rows.indexOf(row) === -1) rows.push(row);
    });

    rows.forEach(function (row) {
      if (!row.classList.contains('bl-gift-line')) {
        row.classList.add('bl-gift-line');

        var cells = row.querySelectorAll(PRICE_SEL);
        Array.prototype.forEach.call(cells, function (cell, i) {
          if (i === 0) {
            cell.innerHTML =
              '<span class="bl-gift-line__was">' + GIFT_VALUE + '</span>' +
              '<span class="bl-gift-line__free">OFFERT</span>';
          } else {
            cell.style.display = 'none';
          }
        });

        if (!row.querySelector('.bl-gift-line__note')) {
          var anchor = row.querySelector(TITLE_SEL);
          if (!anchor) {
            var named = row.querySelectorAll('a[href*="/products/' + GIFT_HANDLE + '"]');
            for (var i = 0; i < named.length; i++) {
              if (named[i].textContent.trim().length > 2) { anchor = named[i]; break; }
            }
          }
          if (anchor) {
            var note = document.createElement('div');
            note.className = 'bl-gift-line__note';
            note.textContent = 'Votre cadeau — il est à vous';
            anchor.insertAdjacentElement('afterend', note);
          }
        }
      }

      var list = row.parentNode;
      if (list && list.lastElementChild && list.lastElementChild !== row) {
        list.appendChild(row);
      }
    });
  }

  /* Our own edits change the DOM, so stop watching while we work.
     Without this the observer retriggers itself and the page locks up. */
  var queued = false;
  function decorate() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      if (observer) observer.disconnect();
      try { decorateOnce(); } catch (e) {}
      if (observer) observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  function init() {
    decorateOnce();
    syncGift().then(function (changed) { if (changed) refreshCartUI(); });

    observer = new MutationObserver(decorate);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
